// HCPCS CONTEXT
export const SET_HCPCS_CHOICE = 'HCPCSGlobalContext.HCPCS.SET_HCPCS_CHOICE';
export const DELETE_HCPCS_CHOICE = 'HCPCSGlobalContext.HCPCS.DELETE_HCPCS_CHOICE';
export const DISABLE_HCPCS_MENU = 'HCPCSGlobalContext.HCPCS.DISABLE_HCPCS_MENU';
export const DELETE_ICD_CODE = 'HCPCSGlobalContext.HCPCS.DELETE_ICD_CODE';
export const ADD_ICD_CODE = 'HCPCSGlobalContext.HCPCS.ADD_ICD_CODE';
export const ADD_SAVED_ICD_CODE = 'HCPCSGlobalContext.ADD_SAVED_ICD_CODE';
export const SET_ICD_SECTION = 'HCPCSGlobalContext.HCPCS.SET_ICD_SECTION';
export const SET_HCPCS_DURATION = 'HCPCSGlobalContext.HCPCS.SET_HCPCS_DURATION';
export const SET_SHOW_HCPCS = 'HCPCSGlobalContext.HCPCS.SET_SHOW_HCPCS';
export const SET_HCPCS_ERROR = 'HCPCSGlobalContext.HCPCS.SET_HCPCS_ERROR';
export const SET_SUBMIT_HCPCS_ERROR = 'HCPCSGlobalContext.HCPCS.SET_SUBMIT_HCPCS_ERROR';
export const SET_HCPCS_CODE_MAP = 'HCPCSGlobalContext.HCPCS.SET_HCPCS_CODE_MAP';
export const RESET_HCPCS = 'HCPCSGlobalContext.HCPCS.RESET_HCPCS';
export const RECORD_DATA = 'HCPCSGlobalContext.HCPCS.RECORD_DATA';
export const SHOW_HCPCS_LOADER = 'HCPCSGlobalContext.HCPCS.SHOW_HCPCS_LOADER';